module.exports = __webpack_public_path__ + "static/media/discard-edit.5223a81d.svg";